<template>
    <div class="right-content">
        <div class="right-content-body">
            <div class="title">
                地球上的自然灾害主要有：
            </div>
            <div class="content">
                <p>地震 滑坡 台风 海啸 冰雹 旱灾 飙风 洪灾 寒潮 雪灾 酸雨</p>
                <p>沙尘暴 荒漠化 暴风潮 龙卷风 泥石流</p>
                <p>水土流失 火山爆发 生物灾害 雪崩 暴风雨</p>
                <div>
                    <img class="float-left" src="../../assets/images/scb.jpg" />
                    <img class="float-right" src="../../assets/images/eq.jpg" />
                </div>
                <div class="center">
                    <img class="float-left" src="../../assets/images/tf.jpg" />
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "DisasterView"
    }
</script>

<style lang="scss" scoped>
    .right-content {
        padding: 30px;
        margin-left: 130px;
        font-size: 13px;
        .right-content-body {
            max-height: 620px;
            overflow-y: auto;
            overflow-x: hidden;
            .title {
                -webkit-text-stroke: 0.05em #33c;
                -webkit-text-fill-color : transparent;
                font-size: 30px;
                text-shadow: 3px 3px 2px #b2b2b2;
                text-align: left;
                font-family: SimSun;
            }
            .center {
                text-align: center;
            }
            p {
                line-height: 50px;
            }
            img {
                margin-left: 30px;
                margin-top: 30px;
            }

        }
    }
</style>